const messages = {
  ru: {
    unknown: 'Не удалось получить подтверждение отправки. Письмо могло дойти. Перед повторной отправкой проверьте у получателя или в почтовом сервисе.',
    savedError: 'Почтовый сервер принял письмо, но VirtualGarage не смог сохранить результат. Не отправляйте письмо повторно только из-за этой ошибки.',
    retry: 'Письмо уже могло быть получено. Вы проверили результат и хотите отправить его ещё раз?',
  },
  en: {
    unknown: 'Sending could not be confirmed. The email may have arrived. Check with the recipient or in your mail service before sending again.',
    savedError: 'The mail server accepted the email, but VirtualGarage could not save the result. Do not resend the email just because of this error.',
    retry: 'The email may already have arrived. Have you checked the result and decided to send it again?',
  },
  et: {
    unknown: 'Saatmist ei saanud kinnitada. Kiri võis kohale jõuda. Enne uuesti saatmist kontrollige tulemust saajaga või oma meiliteenuses.',
    savedError: 'Meiliserver võttis kirja vastu, kuid VirtualGarage ei saanud tulemust salvestada. Ärge saatke kirja uuesti ainult selle vea tõttu.',
    retry: 'Kiri võis juba kohale jõuda. Kas olete tulemust kontrollinud ja soovite selle uuesti saata?',
  },
  fi: {
    unknown: 'Lähetystä ei voitu vahvistaa. Viesti on saattanut saapua. Tarkista vastaanottajalta tai sähköpostipalvelusta ennen uutta lähetystä.',
    savedError: 'Postipalvelin hyväksyi viestin, mutta VirtualGarage ei voinut tallentaa tulosta. Älä lähetä viestiä uudelleen vain tämän virheen vuoksi.',
    retry: 'Viesti on voinut jo saapua. Oletko tarkistanut tuloksen ja haluat lähettää sen uudelleen?',
  },
  lv: {
    unknown: 'Nosūtīšanu neizdevās apstiprināt. Vēstule, iespējams, ir piegādāta. Pirms atkārtotas nosūtīšanas pārbaudiet pie saņēmēja vai savā pasta pakalpojumā.',
    savedError: 'Pasta serveris pieņēma vēstuli, bet VirtualGarage nevarēja saglabāt rezultātu. Nesūtiet vēstuli atkārtoti tikai šīs kļūdas dēļ.',
    retry: 'Vēstule, iespējams, jau ir piegādāta. Vai pārbaudījāt rezultātu un vēlaties nosūtīt vēlreiz?',
  },
  lt: {
    unknown: 'Siuntimo patvirtinti nepavyko. Laiškas galėjo pasiekti gavėją. Prieš siųsdami dar kartą patikrinkite su gavėju arba pašto paslaugoje.',
    savedError: 'Pašto serveris priėmė laišką, bet VirtualGarage negalėjo išsaugoti rezultato. Nesiųskite laiško dar kartą vien dėl šios klaidos.',
    retry: 'Laiškas jau galėjo pasiekti gavėją. Ar patikrinote rezultatą ir norite siųsti dar kartą?',
  },
}

export default function mailSendStatus(locale, key) {
  return (messages[String(locale).split('-')[0]] || messages.en)[key]
}
